import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"cross\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.842.854a.5.5 0 00-.707-.707L3.995 3.29.852.147a.5.5 0 10-.707.707l3.141 3.143L.147 7.14a.5.5 0 00.706.708l3.141-3.144 3.141 3.144a.5.5 0 10.707-.708l-3.14-3.143L7.841.854z\" fill-opacity=\".62\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol